// extracted by mini-css-extract-plugin
export default {"checkmark":"_1NDLg___Checkmark-module__checkmark","show":"_2xnEs___Checkmark-module__show"};